import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './stock.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Stock } from "model/product/stock.model";

export interface StockDetailsProps extends DetailsStateAndDispatchProps<Stock>,
  RouteComponentProps, StateProps, DispatchProps {
}

const StockDetails: FC<StockDetailsProps> = (props) => {

  return (
    <DetailsPage<Stock>
      hideEdit
      title={props.entity?.product?.name}
      {...props}
    >
      <ProDescriptions<Stock>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>
    </DetailsPage>);
};

const mapStateToProps = ({ stock }: RootState) => ({
  entity: stock.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(StockDetails);
